import { Component } from '@angular/core';

@Component({
  selector: 'app-community-benifits',
  imports: [],
  templateUrl: './community-benifits.html',
  styleUrl: './community-benifits.scss',
})
export class CommunityBenifits {

}
